/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';
import dayjs from 'dayjs';

import { Form } from '@mairistem/composants';
import { NaissanceForm } from '@mairistem/adresses';
import { EtatCivil, TypeComponent } from '@mairistem/administres-utils';

import { Section, SectionHeader } from '@/components/Common';
import type { Individu } from '@/types';
import { COLORS } from '@/constants';

interface InformationsNaissanceProps {
  individu: Partial<Individu>;
  dateRecensement?: string;
  errors: Record<string, string>;
  onChange;
}

const InformationsNaissance = (props: InformationsNaissanceProps) => {
  const { individu, errors, onChange, dateRecensement } = props;

  const handleAdresseChange = React.useCallback(
    (adresse) => {
      onChange(null, {
        name: 'adresseNaissance',
        value: {
          ...individu?.adresseNaissance,
          ...adresse,
          ...(!_.isNil(adresse.commune)
            ? { libelleCommune: adresse.commune }
            : {}),
          ...(!_.isNil(adresse.codePostal)
            ? { libelleCodePostal: adresse.codePostal }
            : {}),
          ...(!_.isNil(adresse.pays) ? { libellePays: adresse.pays } : {}),
          ...(!_.isNil(adresse.departement)
            ? { libelleDepartement: adresse.departement }
            : {}),
        },
      });
    },
    [onChange, individu],
  );

  let dateValidite = dayjs().format('YYYY-MM-DD');
  if (
    individu.anneeNaissance &&
    individu.moisNaissance &&
    individu.jourNaissance
  ) {
    dateValidite = `${individu.anneeNaissance}-${individu.moisNaissance}-${individu.jourNaissance}`;
  }

  return (
    <Section title="INFORMATIONS DE NAISSANCE">
      {/* @ts-ignore */}
      <Form style={{ display: 'flex' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            padding: 14,
          }}
        >
          <SectionHeader title="État civil" />
          <EtatCivil
            individu={individu}
            errors={errors}
            onChange={onChange}
            dateRecensement={dateRecensement}
            typeComponent={TypeComponent.RECENSEMENT}
          />
        </div>
        <div
          style={{
            border: `1px solid ${COLORS.DividerColor}`,
            margin: '0px 2rem',
            width: 1,
          }}
        />
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            padding: 14,
          }}
        >
          <SectionHeader title="Lieu de naissance" required />
          <div style={{ padding: '1em' }}>
            <NaissanceForm
              adresse={{
                ...individu?.adresseNaissance,
                codePostal: individu?.adresseNaissance?.libelleCodePostal,
                commune: individu?.adresseNaissance?.libelleCommune,
                pays: individu?.adresseNaissance?.libellePays,
                departement: individu?.adresseNaissance?.libelleDepartement,
              }}
              error={!_.isNil(errors?.adresseNaissance)}
              dateValidite={dateValidite}
              onAdresseChange={handleAdresseChange}
            />
          </div>
        </div>
      </Form>
    </Section>
  );
};

export default InformationsNaissance;
